import styled from 'styled-components'

export const StyledGuestLayout = styled.div``
